import React, { useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  TextField,
  IconButton,
  Box,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";

// Initial dummy data for users
const initialUsers = [
  { id: 1, name: "John Doe", email: "john@example.com", role: "Customer" },
  { id: 2, name: "Jane Smith", email: "jane@example.com", role: "Customer" },
];

const User = () => {
  // State for managing users data
  const [users, setUsers] = useState(initialUsers);

  // State for modal open/close
  const [open, setOpen] = useState(false);

  // State for managing the current user (edit or add)
  const [currentUser, setCurrentUser] = useState({
    id: null,
    name: "",
    email: "",
    role: "",
  });

  // Handler to open the modal
  const handleClickOpen = (
    user = { id: null, name: "", email: "", role: "" }
  ) => {
    setCurrentUser(user);
    setOpen(true);
  };

  // Handler to close the modal
  const handleClose = () => {
    setOpen(false);
  };

  // Handler for saving user (add or edit)
  const handleSave = () => {
    if (currentUser.id) {
      // Editing an existing user
      setUsers((prevUsers) =>
        prevUsers.map((user) =>
          user.id === currentUser.id ? currentUser : user
        )
      );
    } else {
      // Adding a new user
      setUsers([
        ...users,
        { ...currentUser, id: users.length + 1 }, // Assign a new id
      ]);
    }
    handleClose();
  };

  return (
    <div>
      {/* Add New User Button */}
      <Button
        variant="contained"
        color="primary"
        onClick={() => handleClickOpen()}
        startIcon={<AddIcon />}>
        Хэрэглэгч нэмэх
      </Button>

      {/* User Modal (Dialog) */}
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>
          {currentUser.id ? "Засах" : "Хэрэглэгч нэмэх"}
        </DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Нэр"
            type="text"
            fullWidth
            value={currentUser.name}
            onChange={(e) =>
              setCurrentUser({ ...currentUser, name: e.target.value })
            }
          />
          <TextField
            margin="dense"
            label="Email"
            type="email"
            fullWidth
            value={currentUser.email}
            onChange={(e) =>
              setCurrentUser({ ...currentUser, email: e.target.value })
            }
          />
          <TextField
            margin="dense"
            label="Албан тушаал"
            type="text"
            fullWidth
            value={currentUser.role}
            onChange={(e) =>
              setCurrentUser({ ...currentUser, role: e.target.value })
            }
          />
        </DialogContent>

        {/* Dialog Actions with space-between styling */}
        <DialogActions>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
              padding: "15px" // Ensures full width to allow spacing
            }}>
            <Button variant="contained" onClick={handleSave} color="primary">
              {currentUser.id ? "шинэчлэх" : "нэмэх"}
            </Button>
            <Button variant="contained" color="error" onClick={handleClose}>
              хаах
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default User;
